/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadBatch } from './UploadBatch';
import {
    UploadBatchFromJSON,
    UploadBatchFromJSONTyped,
    UploadBatchToJSON,
    UploadBatchToJSONTyped,
} from './UploadBatch';

/**
 * 
 * @export
 * @interface UploadBatchResponse
 */
export interface UploadBatchResponse {
    /**
     * 
     */
    data: UploadBatch;
}

/**
 * Check if a given object implements the UploadBatchResponse interface.
 */
export function instanceOfUploadBatchResponse(value: object): value is UploadBatchResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UploadBatchResponseFromJSON(json: any): UploadBatchResponse {
    return UploadBatchResponseFromJSONTyped(json, false);
}

export function UploadBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': UploadBatchFromJSON(json['data']),
    };
}

export function UploadBatchResponseToJSON(json: any): UploadBatchResponse {
    return UploadBatchResponseToJSONTyped(json, false);
}

export function UploadBatchResponseToJSONTyped(value?: UploadBatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UploadBatchToJSON(value['data']),
    };
}

